import { Fragment } from "react";

export default function Button({
  text,
  color = "primary",
  type = "submit",
  className = "",
  onClick,
  disabled = false,
}) {
  return (
    <Fragment>
      {color === "primary" && (
        <button
          type={type}
          onClick={onClick}
          disabled={disabled}
          className={`text-white h-10 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-8 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
        >
          {text}
        </button>
      )}
      {color === "success" && (
        <button
          type={type}
          onClick={onClick}
          disabled={disabled}
          className={`text-white h-10 bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm w-full sm:w-auto px-8 py-2.5 text-center dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800 disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
        >
          {text}
        </button>
      )}
      {color === "danger" && (
        <button
          type={type}
          onClick={onClick}
          disabled={disabled}
          className={`text-white h-10 bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full sm:w-auto px-8 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800 disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
        >
          {text}
        </button>
      )}
    </Fragment>
  );
}
